import script from "./CircleTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CircleTab.vue?vue&type=script&setup=true&lang=js"

import "./CircleTab.vue?vue&type=style&index=0&id=78d1079c&scoped=true&lang=css"
import "./CircleTab.vue?vue&type=style&index=1&id=78d1079c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d1079c"]])

export default __exports__